// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ButtonStack-module__root--AkYSM {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  gap: 10px;
}

.ButtonStack-module__direction-horizontal--gMIgO {
  flex-direction: row;
}

.ButtonStack-module__direction-horizontal--gMIgO > * {
  min-width: 0;
  flex: 1 0 0;
}

.ButtonStack-module__direction-vertical--Te0xG {
  flex-direction: column;
}

.ButtonStack-module__direction-vertical--Te0xG > * {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/ButtonStack/ButtonStack.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  gap: 10px;\n}\n\n.direction-horizontal {\n  flex-direction: row;\n}\n\n.direction-horizontal > * {\n  min-width: 0;\n  flex: 1 0 0;\n}\n\n.direction-vertical {\n  flex-direction: column;\n}\n\n.direction-vertical > * {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ButtonStack-module__root--AkYSM`,
	"direction-horizontal": `ButtonStack-module__direction-horizontal--gMIgO`,
	"direction-vertical": `ButtonStack-module__direction-vertical--Te0xG`
};
export default ___CSS_LOADER_EXPORT___;
